import _defineProperty from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { configureScope } from '@sentry/browser';
/* eslint-disable @typescript-eslint/no-explicit-any */

var ACTION_BREADCRUMB_CATEGORY = 'redux.action';
var ACTION_BREADCRUMB_TYPE = 'info';
var defaultOptions = {
  actionTransformer: function actionTransformer(action) {
    return action;
  },
  stateTransformer: function stateTransformer(state) {
    return state || null;
  }
};
/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */

function createReduxEnhancer(enhancerOptions) {
  // Note: We return an any type as to not have type conflicts.
  var options = _objectSpread(_objectSpread({}, defaultOptions), enhancerOptions);

  return function (next) {
    return function (reducer, initialState) {
      var sentryReducer = function sentryReducer(state, action) {
        var newState = reducer(state, action);
        configureScope(function (scope) {
          /* Action breadcrumbs */
          var transformedAction = options.actionTransformer(action);

          if (typeof transformedAction !== 'undefined' && transformedAction !== null) {
            scope.addBreadcrumb({
              category: ACTION_BREADCRUMB_CATEGORY,
              data: transformedAction,
              type: ACTION_BREADCRUMB_TYPE
            });
          }
          /* Set latest state to scope */


          var transformedState = options.stateTransformer(newState);

          if (typeof transformedState !== 'undefined' && transformedState !== null) {
            scope.setContext('state', {
              state: {
                type: 'redux',
                value: transformedState
              }
            });
          } else {
            scope.setContext('state', null);
          }
          /* Allow user to configure scope with latest state */
          // eslint-disable-next-line @typescript-eslint/unbound-method


          var configureScopeWithState = options.configureScopeWithState;

          if (typeof configureScopeWithState === 'function') {
            configureScopeWithState(scope, newState);
          }
        });
        return newState;
      };

      return next(sentryReducer, initialState);
    };
  };
}

export { createReduxEnhancer };